import type { SupplementPicker } from 'types/cms/blocks';

import type { ProductCtasProps } from '../ProductCtas';

export const mapSupplementPickerToCtas = (
  supplementPicker: SupplementPicker,
): Omit<ProductCtasProps, 'colorScheme'> => {
  const product = supplementPicker.products[0];
  const { variants } = product;
  const { slug } = product.product;

  return {
    blockId: supplementPicker._key,
    promoCodes: supplementPicker.promoCodes,
    purchaseType: supplementPicker.purchaseType,
    product: {
      slug,
      variants,
    },
  };
};
